module.exports = __webpack_public_path__ + "static/pic01-cc778b38ae981bbb5bf55b07fb52348d.jpg";